import Evaporate        from 'evaporate'
import CloudFlyerAPI       from '../../../../api/CloudFlyerAPI'
import { refresh_profile } from '../../../../actions/auth'
import { message }      from 'antd'
import AWS              from 'aws-sdk'

export default class S3 {

  constructor (service_url, signer_url){
    this.uploaders = {}

    //debugger

    this.service_url = service_url ? service_url : null
    this.signer_url  = signer_url ? signer_url : window.API + '/transfers/url_signer_v4' // '/transfers/s3_url_signer_v4'
    this.signer_url  = signer_url ? signer_url : window.ANALYTICS_API + 'CloudAccount/SignV4'

    this.mb = 1024 * 1024
    this.gb = this.mb * 1024

    this.multipart_upload = {
      min_part_size  : 5 * this.mb,
      max_part_size  : 5 * this.gb,
      max_part_count : 10000
    }
  }

  get_service_url = region =>{
    switch (region) {
      case 'us-west-1':
        return 'https://s3.us-west-1.wasabisys.com'
      case 'eu-central-1':
        return 'https://s3.eu-central-1.wasabisys.com'
      case 'us-east-1':
        return 'https://s3.wasabisys.com'
      default:
          return region ? `https://s3.${region}.wasabisys.com` : 'https://s3.wasabisys.com'
    }
  }

  load_dir_files = function (dir_entry, on_resolved, errorHandler) {
    if (dir_entry.isDirectory) {
      let directory = dir_entry;
      let dirReader = directory.createReader();
      let readEntries = function() {
        dirReader.readEntries (function(entries) {
          if (!entries.length) {
             dirReader = null
             directory = null
            on_resolved(null, null)
          }
          else {
            on_resolved(entries, readEntries)
          }
        }, errorHandler);
      };
      readEntries();
    }
  }

  create_bucket_uploader = (bucket_name, bucket_region, access_key,
                                     cloud_account_id, s3Acceleration, on_created) => {

    let $this = this

    if(this.uploaders[bucket_name])return on_created(this.uploaders[bucket_name])

    if ($this.service_url && $this.service_url.includes('wasabisys.com')) $this.service_url = $this.get_service_url(bucket_region)

    Evaporate.create({
      bucket     : bucket_name,
      aws_key    : access_key,

      signerUrl  : $this.signer_url,
      aws_url    : $this.service_url,

      awsSignatureVersion : '4',
      maxConcurrentParts : 5,
      partSize           : 5 * 1024 * 1024,
      computeContentMd5   : true,

      cloudfront : false,
      awsRegion  : bucket_region || 'us-east-1',
      s3Acceleration     :  s3Acceleration,
      allowS3ExistenceOptimization : true,
      progressIntervalMS  : 1000,
      s3FileCacheHoursAgo : 1,
      cryptoMd5Method         : data => AWS.util.crypto.md5(data, 'base64'),
      cryptoHexEncodedHash256 : data => AWS.util.crypto.sha256(data, 'hex'),
      signParams: {
        cloudId:cloud_account_id,
        bucketName:bucket_name,
        region:bucket_region,
        s3Acceleration
      },
      signHeaders : { Authorization : localStorage.Authorization},
      logging     : false,
      evaporateChanged: function (evaporate, evaporatingCount) {
        evaporate.evaporatingCount = evaporatingCount
      }
    }).then(uploader => {

        uploader.cloud_account_id     = cloud_account_id
        uploader.bucket_name          = bucket_name

        $this.uploaders[bucket_name] = uploader
        on_created(uploader)
      },

      err=> {console.error('Failed to initialize:', err);}
    )
  }

  create_dir_uploader = (bucket_name, bucket_region, access_key,
                                  cloud_account_id, s3Acceleration, on_created) => {

    if (this.service_url && this.service_url.includes('wasabisys.com')) this.service_url = this.get_service_url(bucket_region)

    Evaporate.create({
      bucket     : bucket_name,
      aws_key    : access_key,

      signerUrl  :  this.signer_url,
      aws_url    :  this.service_url,

      awsSignatureVersion : '4',
      maxConcurrentParts  : 5,
      partSize            : 5 * 1024 * 1024,
      computeContentMd5   : true,

      cloudfront : false,
      awsRegion  : bucket_region || 'us-east-1',
      s3Acceleration     : s3Acceleration,
      allowS3ExistenceOptimization : true,
      progressIntervalMS  : 1000,
      s3FileCacheHoursAgo : 1,
      cryptoMd5Method         : data => AWS.util.crypto.md5(data, 'base64'),
      cryptoHexEncodedHash256 : data => AWS.util.crypto.sha256(data, 'hex'),
      signParams: {
        cloudId:cloud_account_id,
        bucketName:bucket_name,
        region:bucket_region,
        s3Acceleration
      },
      signHeaders : {Authorization : localStorage.Authorization},
      logging     : false,
      evaporateChanged: function (evaporate, evaporatingCount) {
        evaporate.evaporatingCount = evaporatingCount
      }
    }).then(uploader => {

        uploader.cloud_account_id = cloud_account_id
        uploader.bucket_name      = bucket_name

        on_created(uploader)
      },

      err=> {console.error('Failed to initialize:', err);}
    )
  }

  keys_count  = function (obj) {
    if(!obj){
      return 0
    }
    return Object.keys(obj).length;
  }

  send_report = function (uploads, s3Acceleration, dir) {
    const report =
      {
        s3_direct : {
          s3Acceleration : s3Acceleration,
          direction      : "upload",
          files          : []
        }
      }

    if(dir && !dir.reported){
      Object.assign(
        report.s3_direct,
        {
          is_directory     : !!dir,
          name             : dir.name,
          bucket_name      : dir.bucket_name,
          cloud_account_id : dir.cloud_account_id,
          s3Acceleration   : dir.s3Acceleration,
          size             : dir.size ? dir.size : dir.uploaded_size,
          file_count      : dir.uploaded_count,
          duration         : dir.endTime - dir.startTime
        }
      )
      dir.reported = true
    }

    for (let key in uploads){
      let upload = uploads[key]
      if(uploads.hasOwnProperty(key) && !upload.reported){
        upload.reported = true
        report.s3_direct.files.push({
          name             : upload.name,
          bucket_name      : upload.bucket_name,
          cloud_account_id : upload.cloud_account_id,
          contentType      : upload.file.type,
          size             : upload.sizeBytes,
          duration         : upload.endTime - upload.startTime
        })
      }
    }

    CloudFlyerAPI.transfer.report(report)
      .then(()=> refresh_profile(true))
      .catch(e => message.error(e.message))
  }

  add_more_files = (dir, add_handler, refresh_handler)=> {

    dir.status = 2
    let floor  = 0

    if(dir.files){
      if(dir.files.length === 0 && this.keys_count(dir.uploads) === 0) {
        dir.status  = 3
        dir.endTime = new Date()

        console.log('########################  we are done with '  + dir.files.length.toString() + ' files ###################')
        console.log('######################## we are done uploading '  + dir.name +' ####################')

        refresh_handler()

        this.send_report([], null, dir)
      }

      floor = (dir.files.length > dir.concurrent ? dir.concurrent : dir.files.length) - this.keys_count(dir.uploads)
      if(floor <= 0){
        floor = dir.files.length
      }

      console.log('Total '  + dir.files.length.toString() + ' files')
      console.log('uploading '  + this.keys_count(dir.uploads).toString() + ' files')
      console.log('adding '  + floor.toString() + ' files')

      for (let f = 0; f < floor; f++){
        let file = dir.files.pop()
        file.fullPath = file.webkitRelativePath
        add_handler(file, dir.bucket_name, dir.cloud_account_id, dir.access_key,
          dir.s3Acceleration, dir.access_control,
          dir.current_path, dir.uploader
        )
      }
    } else {
      if(dir.FileEntries.length < dir.concurrent && dir.resolve_next){
        dir.resolve_next()
      } else if(dir.FileEntries.length === 0 && dir.DirectoryEntries.length === 0 && !dir.resolve_next && this.keys_count(dir.uploads) === 0) {
        dir.status  = 3
        dir.endTime = new Date()

        console.log('########################  we are done with '  + dir.FileEntries.length.toString() + ' files ###################')
        console.log('we are done with '  + dir.DirectoryEntries.length.toString() + ' directory')
        console.log('####################### we are done uploading '  + dir.uploaded_count.toString() + ' files ####################')

        refresh_handler()
      }

      floor = (dir.FileEntries.length > dir.concurrent ? dir.concurrent : dir.FileEntries.length) - this.keys_count(dir.uploads)
      console.log('adding '  + floor.toString() + ' files')

      let queue_file = function (file_entry) {
        file_entry.file(function(file) {
          file.fullPath = file_entry.fullPath
          add_handler(file, dir.bucket_name, dir.cloud_account_id, dir.access_key,
            dir.s3Acceleration, dir.access_control,
            dir.current_path, dir.uploader
          )
        });
      }

      for (let i = 0; i < floor; i++)
        queue_file(dir.FileEntries.pop())
    }
  }

  calculate_optimal_part_size = size =>{
    // max_part_count = 10000 → https://github.com/aws/aws-sdk-java/blob/master/aws-java-sdk-s3/src/main/java/com/amazonaws/services/s3/internal/Constants.java#L76
    // min_part_size  = 5242880

    let optimal_part_size = size/this.multipart_upload.max_part_count
    // round up so we don't push the upload over the maximum number of parts
    optimal_part_size = Math.ceil(optimal_part_size);
    return Math.max(optimal_part_size, this.multipart_upload.min_part_size)
  }

}
